<script>
import { XIcon } from 'vue-feather-icons'
import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  components: { XIcon },
  extends: BaseModal,
  data: function () {
    return {
      pdfURL: ''
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    // its completed, we clear this so it won't be called during $killSession()
    this.removeDeliveryRequestId()
    this.generatePdfUrl()
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    ...mapMutations(['removeDeliveryRequestId']),

    generatePdfUrl() {
      let baseURLWithoutApi = this.$baseURL.slice(0, -4) // slicing off `/api`
      this.pdfURL = `${baseURLWithoutApi}${this.data.shortUrlKey}`
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="$killSession()")
  .modal-body
    h1.page__header {{ $t('d.confirmation.deliveryConfirmationModal.header') }}
    template(v-if="!cp.hideQrOnTabletOnDeliveryConfirmationScreen")
      h3.page__description.mb-5(v-if="!this.$isRemoteClient") {{ $t('d.confirmation.deliveryConfirmationModal.subheader') }}
      .row
        .col-4.offset-4.qr-wrapper.text-center
          p(v-if="this.$isRemoteClient") {{ $t('d.confirmation.deliveryConfirmationModal.confirmationPdfInfo') }}
          qr-code(v-else :text="pdfURL")
      .row
        .col-12.col-lg-6.offset-lg-3
          a.btn.btn-link.btn-block.pseudo-button(
            v-if="this.$isRemoteClient"
            type="button"
            target="_blank"
            :href="pdfURL"
          ) {{ pdfURL }}
          .form-control.w-100.text-center(v-else) {{ pdfURL }}
</template>

<style lang="scss" scoped>
.qr-wrapper {
  display: flex;
  justify-content: center;
  padding: 6rem 0rem;
}
.pseudo-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
